import { useState } from 'react';

/**
 * A list offset that falls back to the first page whenever `resetKey` (the
 * search, a filter) changes, without an extra render at the stale offset.
 */
export function usePagedOffset(resetKey: string): [number, (offset: number) => void] {
  const [paging, setPaging] = useState({ key: resetKey, offset: 0 });
  const offset = paging.key === resetKey ? paging.offset : 0;
  return [offset, (next: number) => setPaging({ key: resetKey, offset: next })];
}
